import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
  name: 'englishInArabicError'
})
export class EnglishInArabicErrorPipe implements PipeTransform {

  transform(value: unknown, ...args: unknown[]): string {
    return 'This field accepts arabic text only.';
  }

}
